import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chartCssClasses',
  standalone: true,
})
export class ChartCssClassesPipe implements PipeTransform {
  transform(css: string | ((options: Highcharts.Options) => string), options: Highcharts.Options): string {
    if (!css) {
      return '';
    }

    return typeof css === 'function' ? css(options) : css;
  }
}
